import { useEffect, useState, useRef } from "react";
import { startTimer, stopTimer } from './utils';
import delay from '../../../utils/delay';

const useRecorder = ({ setTranscription, chapterComplete, chapterStart, currentPageName }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isRecording, setIsRecording] = useState(false);
  const [showMic, setShowMic] = useState(false);

  const isRecordingRef = useRef(false);
  const timerRefPrimary = useRef(null);
  const recorderRefPrimary = useRef(null);
  const timerRefSecondary = useRef(null);
  const recorderRefSecondary = useRef(null);

  const handleStart = async () => {
    setIsRecording(true);
    isRecordingRef.current = true;

    startTimer(timerRefPrimary, recorderRefPrimary, setTranscription);
  
    await delay(3500);

    if(!isRecordingRef.current) {
      return
    }
    startTimer(timerRefSecondary, recorderRefSecondary, setTranscription);
  }

  const handleStop = async () => {
    setIsRecording(false);
    isRecordingRef.current = false;

    stopTimer(timerRefPrimary, recorderRefPrimary);
    stopTimer(timerRefSecondary, recorderRefSecondary);
  }

  const toggleShowMic = () => {
    setShowMic((prevShowMic) => (!prevShowMic))
  }

  const toggleMic = () => {
    isRecording ? handleStop() : handleStart();
  }

  useEffect(() => {
    return () => {
      handleStop();
    }
  }, [])

  useEffect(() => {
    if(chapterComplete) {
      handleStop()
      setIsButtonDisabled(true);
    }
  }, [chapterComplete])

  useEffect(() => {
    if(chapterStart) {
      handleStart()
      setIsButtonDisabled(false);
    }
  }, [chapterStart])

  useEffect(() => {
    if(currentPageName === 'start' || currentPageName === 'cover') {
      handleStop();
    }
  }, [currentPageName])

  return {
    toggleMic,
    isRecording,
    isButtonDisabled,
    showMic,
    toggleShowMic,
  }
}

export default useRecorder;